const MODULO_POR_VISTA = {
  dashboard: 'dashboard',
  clientes: 'clientes',
  'lista-precios': 'lista_precios',
  'nuevo-cliente': 'nuevo_cliente',
  finanzas: 'finanzas',
  'finanzas-calendario': 'calendario_pagos',
  facturacion: 'facturacion',
  balance: 'balance',
  'anteojos-todos': 'estado_anteojos',
  'anteojos-tomados': 'estado_anteojos',
  'anteojos-preparados': 'estado_anteojos',
  'anteojos-laboratorio': 'estado_anteojos',
  'anteojos-para-retirar': 'estado_anteojos',
  'anteojos-entregados': 'estado_anteojos',
  'agregar-cristales': 'herramientas_cristales',
  'stock-armazones': 'herramientas_stock_armazones',
  'vendedor-ecommerce': 'tienda_online',
  'gestion-envios': 'tienda_online',
  mensajeria: 'mensajeria',
  presupuestos: 'presupuestos',
  'estadisticas-ventas': 'estadisticas_ventas',
};

export function obtenerModuloDeVista(view) {
  return MODULO_POR_VISTA[view] || null;
}

export function tieneAccesoModulo(modulosHabilitados, moduloCodigo, esSuperAdmin = false) {
  if (esSuperAdmin) return true;
  if (!moduloCodigo) return true;
  if (moduloCodigo === 'presupuestos') return true;
  if (!Array.isArray(modulosHabilitados) || modulosHabilitados.length === 0) return true;
  return modulosHabilitados.includes(moduloCodigo);
}

export function puedeAccederVista(view, modulosHabilitados, esSuperAdmin = false) {
  const moduloCodigo = obtenerModuloDeVista(view);
  return tieneAccesoModulo(modulosHabilitados, moduloCodigo, esSuperAdmin);
}
